@let appName = this.appName();
@let firstRouteSegment = this.firstRouteSegment();
@let tenantConfigSettings = this.tenantConfigSettings();
@let hideShopLinks = this.hideShopLinks();

<warema-header-menu-item
    [description]="'TOOL_OVERVIEW_DESC.CONFIGURATOR' | translate"
    [icon]="'screwdriverWrench'"
    [label]="'TOOL_OVERVIEW_NAMES.CONFIGURATOR' | translate"
    [selected]="appName === 'warema-designer-web'"
    [title]="'TOOL_OVERVIEW_NAMES.CONFIGURATOR' | translate"
    (click)="clickUrl.emit(getUrl('warema-designer-web'))"
/>

@if (appName === 'warema-plus') {
    <warema-header-menu-item
        [description]="'TOOL_OVERVIEW_DESC.SPECIALIST_DEALERS_SEARCH' | translate"
        [icon]="'location'"
        [label]="'TOOL_OVERVIEW_NAMES.SPECIALIST_DEALERS_SEARCH' | translate"
        [routerLink]="['/company-search-workflow']"
        [selected]="appName === 'warema-plus' && firstRouteSegment === 'company-search-workflow'"
        [title]="'TOOL_OVERVIEW_NAMES.SPECIALIST_DEALERS_SEARCH' | translate"
        (click)="clickRouteRedirect.emit('warema-plus-company-search')"
    />
} @else {
    <warema-header-menu-item
        [description]="'TOOL_OVERVIEW_DESC.SPECIALIST_DEALERS_SEARCH' | translate"
        [icon]="'location'"
        [label]="'TOOL_OVERVIEW_NAMES.SPECIALIST_DEALERS_SEARCH' | translate"
        [title]="'TOOL_OVERVIEW_NAMES.SPECIALIST_DEALERS_SEARCH' | translate"
        (click)="clickUrl.emit(getUrl('warema-plus', 'company-search-workflow'))"
    />
}

@if (tenantConfigSettings?.shop && tenantConfigSettings?.shop?.enabled && !hideShopLinks) {
    @if (appName === 'warema-plus') {
        <warema-header-menu-item
            id="shop-button"
            [description]="'TOOL_OVERVIEW_DESC.SAMPLE_SHOP' | translate"
            [icon]="'cart'"
            [label]="'TOOL_OVERVIEW_NAMES.SAMPLE_SHOP' | translate"
            [routerLink]="'/shop'"
            [selected]="firstRouteSegment === 'shop'"
            [title]="'TOOL_OVERVIEW_NAMES.SAMPLE_SHOP' | translate"
            (click)="clickRouteRedirect.emit('warema-plus-shop')"
        />
    } @else {
        <warema-header-menu-item
            id="shop-button"
            [description]="'TOOL_OVERVIEW_DESC.SAMPLE_SHOP' | translate"
            [icon]="'cart'"
            [label]="'TOOL_OVERVIEW_NAMES.SAMPLE_SHOP' | translate"
            [title]="'TOOL_OVERVIEW_NAMES.SAMPLE_SHOP' | translate"
            (click)="clickUrl.emit(getUrl('warema-plus') + '/shop')"
        />
    }
}

@if (appName === 'warema-plus') {
    <warema-header-menu-item
        [description]="'TOOL_OVERVIEW_DESC.WAREMA_PLUS' | translate"
        [icon]="'person'"
        [label]="'TOOL_OVERVIEW_NAMES.WAREMA_PLUS' | translate"
        [routerLink]="'/'"
        [selected]="firstRouteSegment !== 'company-search-workflow' && firstRouteSegment !== 'shop'"
        [title]="'TOOL_OVERVIEW_NAMES.WAREMA_PLUS' | translate"
    />
} @else {
    <warema-header-menu-item
        [description]="'TOOL_OVERVIEW_DESC.WAREMA_PLUS' | translate"
        [icon]="'person'"
        [label]="'TOOL_OVERVIEW_NAMES.WAREMA_PLUS' | translate"
        [title]="'TOOL_OVERVIEW_NAMES.WAREMA_PLUS' | translate"
        (click)="clickUrl.emit(getUrl('warema-plus'))"
    />
}

<warema-header-menu-item
    [description]="'TOOL_OVERVIEW_DESC.COLLECTION_ASSISTANT' | translate"
    [icon]="'fabrics'"
    [label]="'TOOL_OVERVIEW_NAMES.COLLECTION_ASSISTANT' | translate"
    [selected]="appName === 'warema-collection-assistant'"
    [title]="'TOOL_OVERVIEW_NAMES.COLLECTION_ASSISTANT' | translate"
    (click)="clickUrl.emit(getUrl('warema-collection-assistant'))"
/>

<warema-header-menu-item
    [description]="'TOOL_OVERVIEW_DESC.WEBSITE' | translate"
    [icon]="'externalLink'"
    [label]="'TOOL_OVERVIEW_NAMES.WEBSITE' | translate"
    [title]="'TOOL_OVERVIEW_NAMES.WEBSITE' | translate"
    (click)="clickUrl.emit(getUrl('warema-com-tool-overview'))"
/>
